import gql from "graphql-tag"

export const UPDATE_IDEA = gql`
  mutation UPDATE_IDEA(
    $ideaTitle: String!
    $ideaDescription: String!
    $ideaStage: Int!
    $ideaIndustry: Int!
    $id: ID!
  ) {
    updateIdea(
      id: $id
      title: $ideaTitle
      elevatorPitch: $ideaDescription
      ideaStage: $ideaStage
      ideaIndustry: $ideaIndustry
    ) {
      success
    }
  }
`
export const UPDATE_IDEA_STATUS = gql`
  mutation UPDATE_IDEA($id: ID!, $isActive: Boolean!) {
    updateIdea(id: $id, isActive: $isActive) {
      success
    }
  }
`

export const CREATE_IDEA = gql`
  mutation CREATE_IDEA(
    $ideaTitle: String!
    $ideaDescription: String!
    $ideaStage: Int!
    $ideaIndustry: Int!
  ) {
    addIdea(
      title: $ideaTitle
      elevatorPitch: $ideaDescription
      ideaStage: $ideaStage
      ideaIndustry: $ideaIndustry
    ) {
      id
      title
      elevatorPitch
      ideaStage {
        itemId
      }
      ideaIndustry {
        itemId
      }
    }
  }
`
